import { render, staticRenderFns } from "./VLink.vue?vue&type=template&id=66902a7a&"
import script from "./VLink.vue?vue&type=script&lang=js&"
export * from "./VLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports